<template>
<!-- 具体可参考src/components/common/tagManage/Core.vue文件
<transition-group class="mt05x cb ml05x_E mt05x_E fL_E" v-on:leave="el=>{transitionAction('hide',el);}" :duration="500">
	<TagBox v-for="tag in tagList" :key="tag.id" :styleType="'tag'" :val="tag.name" :data="tag" @Remove="onRemove(tag.id)"></TagBox>
</transition-group>
 -->
<div class="tagBox cb fL_E" :class="{'bgLight cSub hover-main tra-fast':styleType=='def','bgMain tag':styleType=='tag'}">
	<div class="tableSys-noWidth vaM_E" :class="{'sizeS':styleType=='def'}" :title="outData(val)">
		<div class="content w20x-max textCut">
			<span v-if="title" class="cSub pl05x">{{title+": "}}</span>
			<span v-if="iVal" :class="{cMain:title&&styleType=='def'}">{{outData(iVal)}}</span>
		</div>
		<div v-if="removeButton" class="removeButton icoSys w1x curP">
			<button class="w1x h1x hover-effect-rotate tra-fast" @click="remove"><Icon name="no" class="w1x h1x" :class="{'fSub hover-f-error':styleType=='def','fWhite':styleType=='tag'}" :sizeBase="'xs'" /></button>
		</div>
	</div>
	<slot></slot>
</div>
</template>
<script>

export default{
	components:{},
	props:{
		title:{
			type:String,
			default:""
		},
		data:{
			type:Object,
			default:null
		},
		val:{
			type:[String,Array],
			default:""
		},
		styleType:{
			type:String,
			default:"def"//def:默认样式，类似于高级筛选生效项目；tag：生效标签的显示；
		},
		removeButton:{//移除按钮控制
			type:Boolean,
			default:true
		}
	},
	data(){
		return{
			iVal:this.val
		}
	},
	watch:{
		val:function(val,oldVal){
			if(val===""){//仅删除ui
				this.remove(false);
			}
			else if(val===undefined||val===null){//非正常值进行移除动作
				// this.$nextTick(()=>{
				// 	this.iVal=oldVal;console.log(this.val,this.iVal)
				// });
				this.remove();
			}
			else{//正常值，展示或更新值
				if(this.iVal===this.val){//第一次运行使用动画展示
					this.show();
				}
				else this.iVal=this.val;//已展示，只需更新
			}
		}
	},
	methods:{
		outData(val){
			if($.type(val)=="array") return val.join(" ");
			else return val;
		},
		show:function(){
			let $this=$(this.$el);
			let ml=$this.css("margin-left");
			let tW=$this.innerWidth();//.find(".tagBox")
			$this.css({
				transition: "none",
				// display: "table",
				width: 0,
				opacity: 0,
				"margin-left": 0
			}).removeClass("show").stop(true,true).animate({
				opacity: 1,
				width: tW,
				"margin-left": ml
			},500,"easeInOutExpo",function () {//清空因动画产生的样式
				$this.css({
					transition: "",
					// display: "",
					width: "",
					opacity: "",
					"margin-left": ""
				});
				// setTimeout(lib.fillHeight,100);
			});
		},
		// hide:function(fn){
		// 	$(this.$el).css({"transition": "none"}).stop(true,true).animate({
		// 		opacity: 0,
		// 		width: 0,
		// 		"margin-left":0,
		// 		"padding":0
		// 	},500,"easeInOutExpo",()=>{
		// 		if(fn) fn();
		// 	});
		// },
		remove(emit=true){
			// this.hide();
			if(emit!==false) this.$emit('Remove',this.iVal,this.data);
		}
	},
	created(){},
	computed:{},
	mounted(){
		this.show();
	}
}
</script>
<style lang="scss" scoped>
.tagBox{line-height:1;padding:{left:.5em;right:.5em;};border-radius:3em;
	&.tag{}
	.removeButton{padding:{left:.2em;};//position:relative;
		//>*{margin:{left:-.5em;};position:absolute;left:50%;top:50%;}
		>*{margin:{top:.08em;};}
		svg{padding:0;}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/TagBox.vue